import { TextFieldWrapper } from "../style/ConditionSelector.styled";

export default function TextFieldView () {
    return (
        <TextFieldWrapper>
            <div>* 선택된 상품이 판매된 스토어가 조회됩니다.</div>
            <div>* 선택된 스토어들의 판매 데이터를 비교할 수 있습니다.</div>
        </TextFieldWrapper>
    )
}